import styled from "styled-components";

import { SelectInputOptionsStyledProps as Props } from "./SelectInputOptions.types";
import CONSTANTS from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const SelectInputOptionsStyled = styled.div<Props>`
  background-color: var(--palette-mid-blue-s15-l8);
  border-radius: 1.6rem;
  padding: 2.4rem;
  min-width: 40rem;

  @media (max-width: ${mobile}px) {
    padding: 2.4rem 0.8rem;
  }

  .SelectInputOptions {
    &__rest {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: var(--palette-black);
      opacity: 0.7;
    }

    &__close {
      align-self: flex-end;
    }

    &__text {
      font-weight: 600;
      color: var(--palette-white);
    }

    &__title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding-top: 3.2rem;
      color: var(--palette-white);
    }

    &__options {
      max-height: 50rem;
      padding: 6.4rem 0;
    }

    &__option {
      margin-top: 1.2rem;
    }

    &__firstOption {
      margin-top: 0;
    }

    &__button {
      width: 100%;
      margin-top: 2.4rem;
      padding: 1.6rem 0;
      font-weight: 600;
      font-size: 1.4rem;
    }
  }
`;

export default SelectInputOptionsStyled;
